import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../siteConfig.js";

export default function Contact() {
  return (
    <div className="container section">
      <div className="pageHero">
        <div className="pageHeroText">
          <span className="eyebrow">Get in touch</span>
          <div className="pageHeroTitle">We're here to help.</div>
          <p className="pageHeroSub">
            Whether you're a customer, rider, merchant, or regulator — reach out and we'll
            get back to you promptly.
          </p>
        </div>
      </div>

      <div className="contactGrid">
        <div className="contactCard">
          <div className="contactCardIcon">📧</div>
          <div className="contactCardTitle">Customer support</div>
          <p className="contactCardDesc">
            Questions about your order, delivery, returns, or payment? Email us and our support
            team will respond as quickly as possible.
          </p>
          <a href={`mailto:${siteConfig.supportEmail}`} className="contactCardLink">
            {siteConfig.supportEmail} →
          </a>
        </div>
        <div className="contactCard">
          <div className="contactCardIcon">🚴</div>
          <div className="contactCardTitle">Become a rider</div>
          <p className="contactCardDesc">
            Interested in delivering for Rahisi? We're always looking for reliable riders across Nairobi.
            Email us with "Rider Application" in the subject line.
          </p>
          <a href={`mailto:${siteConfig.supportEmail}?subject=Rider Application`} className="contactCardLink">
            Apply now →
          </a>
        </div>
        <div className="contactCard">
          <div className="contactCardIcon">🏪</div>
          <div className="contactCardTitle">Merchant partnerships</div>
          <p className="contactCardDesc">
            Want to list your products on Rahisi and reach thousands of customers in Nairobi?
            Email us with "Merchant Inquiry" in the subject line.
          </p>
          <a href={`mailto:${siteConfig.supportEmail}?subject=Merchant Inquiry`} className="contactCardLink">
            Partner with us →
          </a>
        </div>
        <div className="contactCard">
          <div className="contactCardIcon">⚖️</div>
          <div className="contactCardTitle">Legal & compliance</div>
          <p className="contactCardDesc">
            For privacy requests, regulatory notices, or formal legal correspondence, include
            "Legal" or "Privacy" in your subject line to ensure proper routing.
          </p>
          <a href={`mailto:${siteConfig.supportEmail}?subject=Legal Notice`} className="contactCardLink">
            Send notice →
          </a>
        </div>
      </div>

      <div className="inlineLinks" style={{ marginTop: "40px" }}>
        <Link to="/privacy">Privacy Policy</Link>
        <span className="dot">•</span>
        <Link to="/terms">Terms & Conditions</Link>
        <span className="dot">•</span>
        <Link to="/governance">Governance</Link>
      </div>
    </div>
  );
}
